import GameObject from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import SpriteComponent from '../../../Component/Render/Sprite';
import { delay } from '../../../Utility/Task/TaskQueue';

export class RopeBreak extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        try {
            const ropeSprite: SpriteComponent = gameObject.getComponent(
                SpriteComponent
            );

            const frames = [
                'rope_animation0',
                'rope_animation1',
                'rope_animation2',
                'rope_animation3',
                'rope_animation4',
                'rope_animation5',
                'rope_animation6',
                'rope_animation7',
                'rope_animation8',
                'rope_animation9',
                'rope_animation10',
                'rope_animation11',
                'rope_animation12',
                'rope_animation13',
                'rope_animation14',
            ];

            if (ropeSprite) {
                const fps = 24;
                const msPerFrame = 2000 / fps;
                for (let i = 0; i < frames.length; i++) {
                    ropeSprite.texture = frames[i];
                    yield* delay(msPerFrame);
                }
            }
        } catch (e) {
            console.warn(e);
        }
    }
}
